import React, { Fragment, useEffect, useRef, useContext } from 'react';
import { useAsync } from 'react-use';
import { getTopNews } from '../../core/services/news';
import { AppContext } from '../../core/Contexts/AppContext';
import Blog from '../../component/Section/Blog';
import SliderConstruction from '../../component/Slider/SliderConstruction';
import ActionBlock from '../../component/Section/Action';

const Index = (props) => {
  const { setTitle, setHeaderType } = useContext(AppContext);
  const actions = [
    {
      img: './../images/logos/caution.png',
      title: 'საფრთხის შემცველი პროდუქტები',
      path: '/dangerproducts',
    },
    {
      img: './../images/logos/horn.png',
      title: 'განაცხადე საფრთხის შემცველ პროდუქტზე',
      path: '/aboutdangerproducts',
    },
    {
      img: './../images/logos/measurement.png',
      title: 'კანონმდებლობა',
      path: '/legislation',
    },
    {
      img: './../images/logos/share.png',
      title: 'საჯარო ინფორმაცია',
      path: '/publicinfo',
    },
    {
      img: './../images/logos/judgement1.png',
      title: 'ადმინისტრაციული სამართალდარღვევის ოქმი და დადგენილება',
      path: '/penalty',
    },
    {
      img: './../images/logos/judgement.png',
      title: 'სტატისტიკა',
      path: '/statistics',
    },
  ];

  const news = useAsync(getTopNews, []);

  useEffect(() => {
    setHeaderType(2);
  }, []);

  return (
    <Fragment>
      <ActionBlock actions={actions} onClick={actions.url} />

      <section className='overflow-hidden mb-4 p-9'>
        <SliderConstruction />
      </section>
      <div className='blog-sec'>
        {!news.loading && <Blog blog={news.value} title={'სიახლეები'} />}
      </div>
    </Fragment>
  );
};

export default Index;
